<template>
  <div>
    <van-list v-model="loading"
              :finished="finished"
              @load="getDeliveryOrder"
              v-if="list.length != 0">
      <li v-for='(item,index) in list'
          :key='index'>
        <div class="center"
             :class="{mt30:item.state == 3}">
          <div class="order-info f24" @click="toExpress(item)"
               v-if='item.state != 4'>
            <span style="color:#7ADFDF" v-if='item.expressPlatformId == 2 && item.expressCode'>顺丰单号：{{item.expressCode}}</span>
            <span>&nbsp;</span>
            <span class="status">{{item.stateText}}</span>
          </div>
          <div class="server-container">
            <div v-for='(item2,index2) in item.deliveryOrderGoodsBos'
                 :key='index2'>
              <booking-order-com :model='item2' :fatherItem="item" />
              <order-service-list :model='item2.goodsCuringServiceBoList'
                                  style="margin-top: 10px" />
            </div>
          </div>

          <div class="btn-wrap">
                    <button v-if="item.state==3"
                    class="btn-small-highlight-round"
                    style='margin-left:10px;margin-right:0px'
                    @click='speedDetail(item)'>进度详情</button>
                    
              <!-- <button class="btn-small-default-round btn"
                      v-if='item.state == 2'
                      @click="lookExpress(item)">查看物流</button> -->

              <button class="btn-small-default-round"
                      v-if='item.state == 3&&item.showEvaluate&&item.hasDay>=0'
                      @click="$router.push({name:'sendFeedbackIndex',query:{orderId:item.id}})">评价</button>
              <button class="btn-small-highlight-round"
                      v-if='item.state == 0 && item.showShareBtn && item.showBtns'
                      style='margin-left:10px'
                      @click="share">分享有礼</button>
              <button class="btn-small-default-round"
                      v-if='item.state == 2'
                      @click='received(item)'>确认收货</button>

              <button class="btn-small-default-round"
                      v-if='item.state != 2 && item.showBtns'
                      @click="$router.push({name:'diagnosis',query:{id:item.goodsListId}})">诊断方案</button>

              <!-- <button class="btn-small-default-round btn"  v-if='item.showBtns'  @click="$router.push({name:'effects',query:{id:item.goodsListId}})">效果方案</button> -->
              <span class='more_btn'
                    v-if='item.state == 2 && item.showBtns'
                    @click='item.setTips = !item.setTips'>更多</span>
              <div class='tips_btn'
                   v-if='item.setTips'
                   @click="$router.push({name:'diagnosis',query:{id:item.goodsListId}})">
                诊断方案
              </div>
              <div class='tips_btn'
                   v-if='item.showBtns'
                   @click="$router.push({name:'effects',query:{id:item.goodsListId}})">
                效果方案
              </div>
              <!-- <button class="btn-small-default-round btn">
              <div  :id="'alldo'+item.code"  style="position:absolute;width: 70px;height:40px;z-index:999;background-color: red;">
              </div>
              联系客服</button> -->
          </div>

        </div>
      </li>

      <div class="bottomShare">
          <div>扫码~定制你的专属周边~</div>
          <img src="/images/base/share_ewm.png" alt="">
      </div>

    </van-list>
    <div v-else>
      <img src='/images/order/noOrder.png'
           class='no-list'>
    </div>

    <van-popup position="bottom"
               v-model="expressShow">
      <div class='containerRefond f28 content'>
        <div class="title">物流信息</div>
        <div class="close"
             @click="expressShow = false"></div>
        <ul>
          <li v-for='(item,index) in expressLog'
              class='refundLi'
              :class='{active : !index }'>
            <div class='time'>
              <div>
                {{item.acceptDate}}
              </div>
              <div>
                {{item.acceptTime}}
              </div>
            </div>
            <span class='round'>
              <span></span>
            </span>
            <div class='text'>
              <div class='item_title'>{{item.remark}}</div>
              <div class='dero'>{{item.acceptAddress}}</div>
            </div>
          </li>
        </ul>
      </div>
    </van-popup>
  </div>
</template>

<script>
import orderApi from '@/axios/order'
import { Dialog } from 'vant';
import { Toast } from 'vant';
import wxShare from "@/assets/js/wx.share"
import getWXConfig from "@/assets/js/wx.config";
import zhugeObj from '@/assets/js/track';
export default {
  name: 'complateOrders',
  props: {
    ptype: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      expressLog: [],
      expressShow: false,
      loading: true,
      finished: false,
      list: [],
      page: {
        current: 1,
        size: 5
      },
      isMore: true,
      host: window.location.host
    }
  },
  created() {
    this.getDeliveryOrder();

  },
  mounted() {
    zhugeObj.track({
      title: '订单已完成-曝光',
    })
  },
  computed: {
    servicePhone() {
      return this.$store.state.servicePhone;
    },
    customerId() {
      return this.$store.state.customerId;
    }
  },
  methods: {
    toExpress(item) {
      if(item.state!=4 && item.expressPlatformId == 2 && item.expressCode) {
        this.$router.push({name: 'expressDetail',query: {id:item.id,code:item.expressCode}})
      }
    },

    speedDetail(item) {
      this.$router.push({ name: 'speedDetail', query: { id: item.deliveryOrderGoodsBos[0].id } })
      zhugeObj.track({
        title: '进度详情-点击',
        content: {
          '订单列表名称': '已完成'
        }
      })
    },
    setButton() {
      for (let obj of this.list) {
        getWXConfig({ path: 'http://mi.baozheng.cc' })
        let dom = document.getElementById('alldo' + obj.code) //
        console.log('alldo' + obj.code)
        let key = encodeURIComponent('送货单号已复制，可在输入框中粘贴后发给客服')
        let value = encodeURIComponent('送货单号：' + obj.code)
        dom.innerHTML = '<wx-open-launch-weapp path="pages/kefu/index.html?key=' + key + '&value=' + value + '" id="launch-btn"   username="gh_f36f18f6beed"><template><div style="width:80px;height:40px;position: relative;top:-10px;background-color: green;"></div></template></wx-open-launch-weapp>'

        let launchBtn = document.getElementById('launch-btn')
        if (!launchBtn) {
          return
        }
        launchBtn.addEventListener('launch', function (e) {
          zhugeObj.track({
            title: "个人中心-在线咨询-点击"
          });
        })
        launchBtn.addEventListener('error', function (e) {
          console.log('fail', e.detail)
        })
      }
    },
    setShareAction() {

      let shareBody = {};
      orderApi.shareConfig({ configType: 1 }).then((res) => {
        res.forEach((item, index) => {
          if (item.servicePhoneList) {
            if (item.servicePhoneList.indexOf(this.servicePhone) > -1) {
              shareBody = item;
            }
          }

        });

        if (JSON.stringify(shareBody) == '{}') {
          res.forEach((item, index) => {
            if (!item.servicePhoneList || item.servicePhoneList.length == 0) {
              shareBody = item
            }
          });
        }
        shareBody.link = location.origin + "/link/" + shareBody.link;

        setTimeout(() => {
          if (this.ptype != 5) {
            return;
          }

          wxShare(shareBody).then(() => {

          });
        }, 1000)
      })
    },
    share() {

      zhugeObj.track({
        title: '送货列表-分享有礼'
      })
      window.location.href = 'http://support.baomaiduole.com/order/newShare?token=' + this.$store.state.token + '&custormerId=' + this.$store.state.customerId + '&servicePhone=' + this.$store.state.servicePhone

    },
    lookExpress(item) {
      // this.$emit('lookExpress',item);
      orderApi.deliveRoute(item.id).then((res) => {
        if (!res) {
          this.$emit('lookExpress', item);
          return;
        }
        if (res.length == 0) {
          this.$emit('lookExpress', item);
          return;
        }
        this.expressShow = true;
        this.expressLog = res;
      })
    },
    received(item) {
      Dialog.confirm({
        title: '提示',
        message: '请确认是否收到宝贝？',
      }).then(() => {
        // on confirm
        orderApi.received(item.id).then((res) => {
          Toast('收货成功');
          this.list = [];
          this.page = {
            current: 1,
            size: 5
          }
          this.finished = false;
          this.getDeliveryOrder();
          setTimeout(()=>{
            this.$router.push({name:'sendFeedbackIndex',query:{orderId:item.id}})
          },1000)
        })
      }).catch(() => {
        // on cancel

      });
    },
    getDeliveryOrder() {

      if (!this.isMore) {
        return;
      }
      this.isMore = false;
      let params = {
        current: this.page.current,
        size: this.page.size
      }
      orderApi.getDeliveryOrder(params).then((res) => {
        this.loading = false;
        this.isMore = true;
        // console.log()

        this.setShareAction()
        // return;

        res.records.forEach(element => {
          element.setTips = false;
          let arr = [];
          //需要过滤掉赠品
          if (element.deliveryOrderGoodsBos) {
            let its = 0;
            element.deliveryOrderGoodsBos.forEach((item) => {
              if (item.type != 2) {
                arr.push(item.id);
              } else {
                its++;
              }

            })
            if (its == element.deliveryOrderGoodsBos.length) {
              element.showBtns = false;
            } else {
              element.showBtns = true;
            }
            element.goodsListId = arr.join(',');
          }

          element.hasDay = -1
          if(element.updateTime) {
            // 创建当前日期对象
            const today = new Date();
            const targetDate = new Date(element.updateTime);
            const timeDiff = Math.abs(targetDate - today);
            const daysDiff = Math.ceil(timeDiff / (1000 * 60 * 60 * 24));
            element.hasDay = 90 - daysDiff
          }

        });

        this.list = this.list.concat(...res.records || []);
        // setTimeout(()=>{
        //   this.setButton()
        // },1000)
        if (res.totalPage == this.page.current || res.totalPage == 0) {
          this.finished = true;
        }
        if (res.records.length == 0) {
          this.finished = true;
        }
        this.page.current++;
      })
    }
  }
}
</script>

<style scoped lang="scss">
.bottomShare{
  width: 690px;
  padding-top: 20px;
  text-align: center;
  font-size: 26px;
  img{
    width: 150px;
    height: 150px;
    display: block;
    margin: 20px auto 0;
  }
}
.tips_btn {
  width: 152px;
  height: 68px;
  text-align: center;
  background: url("/images/public/btntips.png") no-repeat center center;
  background-size: 100%;
  color: #fff;
  font-size: 24px;
  line-height: 78px;
  position: absolute;
  left: 30px;
  top: 43px;
}
.more_btn {
  position: absolute;
  color: #666666;
  font-size: 24px;
  top: 13px;
  left: 30px;
}
.mt30 {
  margin-top: 30px;
}
.no-list {
  width: 100%;
  margin-top: 300px;
}
.van-list {
  display: flex;
  align-items: center;
  flex-direction: column;

  li {
    width: 690px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 2px 20px 0px rgba(0, 0, 0, 0.1);
    border-radius: 6px;
    margin-top: 30px;
    .center {
      & > div {
        padding: 0 30px;
      }
      .order-info {
        padding: 30px;
        display: flex;
        justify-content: space-between;
        .status {
          color: #f47779;
          // font-size: 28px;
          font-weight: 600;
        }
      }
      .server-container {
        & > div {
          margin-bottom: 20px;
        }
      }
      .kefu-order {
        padding: 0;
      }
      .express-info {
        margin-top: 10px;
        .item {
          display: flex;
          justify-content: space-between;
          line-height: 40px;
          .left {
            color: $primary-color;
            .tip {
              color: #999;
            }
          }
          .right {
            color: #666;
          }
          &:last-child {
            margin-bottom: 38px;
          }
        }
      }
      .pkg-info {
        display: flex;
        flex-direction: row-reverse;
        align-items: flex-end;
        line-height: 40px;
        span {
          margin-left: 10px;
        }
      }
      .btn-wrap {
        margin: 30px 0;
        display: flex;
        flex-direction: row-reverse;
        position: relative;
        .btn {
          margin-right: 20px;
        }
      }
    }
  }
}

.active {
  color: #7adfdf !important;
  span {
    color: #7adfdf !important;
  }
  div {
    color: #7adfdf !important;
  }
  .round {
    border: 1px solid #7adfdf !important;
    span {
      background: #7adfdf !important;
    }
  }
}
.containerRefond {
  padding: 30px;
  position: relative;
  padding-bottom: 90px;
  // padding-left:100px;
  .title {
    line-height: 40px;
    margin-bottom: 50px;
    font-weight: 500;
  }
  .close {
    width: 36px;
    height: 36px;
    position: absolute;
    top: 30px;
    right: 30px;
    background: url("/images/public/close.png") no-repeat center;
    background-size: 32px;
  }
  ul {
    padding-left: 100px;
    padding-top: 10px;
    max-height: 600px;
    overflow: scroll;
    li {
      line-height: 40px;
      margin-top: 60px;

      padding-left: 40px;
      position: relative;
      border-left: 1px solid #e4e4e4;

      .text {
        position: relative;
        top: -52px;
        color: #999999;
        font-size: 24px;
        .item_title {
          margin-bottom: 30px;
          font-size: 28px;
        }
      }
      .time {
        position: absolute;
        top: -55px;
        left: -95px;
        font-size: 14px;
        color: #999999;
        line-height: 22px;
      }
      .round {
        width: 36px;
        height: 36px;
        display: inline-block;

        // background: #D2D2D2;
        border: 1px solid #d2d2d2;
        border-radius: 50%;
        position: absolute;
        left: -19px;
        top: -50px;
        text-align: center;
        span {
          width: 28px;
          height: 28px;
          background: #d2d2d2;
          display: inline-block;
          margin-top: 4px;

          border-radius: 50%;
        }
      }
      time {
        float: right;
      }
    }
  }
}
</style>
